import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadAnalytics, trackPageView } from "@/lib/analytics";

// Charge GA4 si le consentement est déjà donné, puis envoie une vue à chaque
// changement de page (navigation SPA). À placer dans <BrowserRouter>.
export const AnalyticsListener = () => {
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    loadAnalytics();
  }, []);

  useEffect(() => {
    if (first.current) {
      first.current = false; // la 1re vue est envoyée par loadAnalytics()
      return;
    }
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};
